import {
    RSS_LOADING_STATUS,
    GET_RSS_PODCASTS,
    CLEAR_RSS_PODCASTS,
    SET_RSS_PODCAST,
    CLEAR_RSS_PODCAST,
    SET_RSS_PLAYLIST,
    CLEAR_RSS_PLAYLIST,
    RSS_PLAY_STATUS
} from './types'

const initialState = {
    podcasts: [],
    podcastNumber: null,
    isLoading: false,
    playlist: null,
    currentPodcast: null,
    play: false
}

export const state = { ...initialState }

export default {
    [RSS_LOADING_STATUS]: (state, status) => {
        state.isLoading = status
    },
    [GET_RSS_PODCASTS]: (state, payload) => {
        state.podcasts = payload
    },
    [CLEAR_RSS_PODCASTS]: (state) => {
        state.podcasts = []
    },
    [SET_RSS_PODCAST]: (state, {podcast, podcastNumber}) => {
        state.currentPodcast = podcast
        state.podcastNumber = podcastNumber
    },
    [CLEAR_RSS_PODCAST]: (state) => {
        state.currentPodcast = null
        state.podcastNumber = null
    },
    [SET_RSS_PLAYLIST]: (state, playlist) => {
        state.playlist = playlist
    },
    [CLEAR_RSS_PLAYLIST]: (state) => {
        state.playlist = null
    },
    [RSS_PLAY_STATUS]: (state, status) => {
        state.play = status
    }
}